export default __webpack_public_path__ + "static/media/activity-7.4d3b4915.png";